import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "../style";

export const StormSurgeUSLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();
  //["#f9f9f9", "#4D8FC2", "#2ABB8C", "#F9E03F", "#FAA945", "#CF000F"]
  return (
    <div style={customLegendStyle}>
      <div>
        <b>Storm Surge Cat 1</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>
        {t("levels.noHazard")}
      </div>

      <div>
        <span style={legendItemStyle("#1F78B4")}></span>
        {t("levels.low")}: 1 &lt; pw &lt; 3
      </div>
      <div>
        <span style={legendItemStyle("#F0F030")}></span>
        {t("levels.moderate")}: 4 &le; pw &lt; 6
      </div>
      <div>
        <span style={legendItemStyle("#FA741B")}></span>
        {t("levels.significant")}: 7 &le; pw &lt; 9
      </div>
      <div>
        <span style={legendItemStyle("#FF0A12")}></span>
        {t("levels.high")}: 10 &le; pw &lt; 12
      </div>
      <div>
        <span style={legendItemStyle("#6C6C6C")}></span>
        {t("levels.veryHigh")}: pw &ge; 12
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          processed by CyStellar
        </span>
      </div>
    </div>
  );
};
